module.exports = __webpack_public_path__ + "static/media/electroscope.2b0e0acf.png";